import { createAction, props } from '@ngrx/store';

import { ClientDocumentGroup, DocumentOverviewBucket, DocumentOverviewModel } from '../models/document-overview.models';

export const loadDocumentOverview = createAction('[DocumentOverview] loadDocumentOverview', props<{ batchId: string }>());

export const loadDocumentOverviewSuccess = createAction(
  '[DocumentOverview] loadDocumentOverviewSuccess',
  props<{ overview: DocumentOverviewModel }>()
);

export const loadDocumentOverviewError = createAction('[DocumentOverview] loadDocumentOverviewError', props<{ error: string }>());

export const loadClientDocumentOverview = createAction('[DocumentOverview] loadClientDocumentOverview');

export const loadClientDocumentOverviewSuccess = createAction(
  '[DocumentOverview] loadClientDocumentOverviewSuccess',
  props<{ overview: DocumentOverviewModel }>()
);

export const loadClientDocumentOverviewError = createAction(
  '[DocumentOverview] loadClientDocumentOverviewError',
  props<{ error: string }>()
);

export const loadMoreClientDocuments = createAction(
  '[DocumentOverview] loadMoreClientDocuments',
  props<{ group: ClientDocumentGroup; after: string }>()
);

export const loadMoreClientDocumentsSuccess = createAction(
  '[DocumentOverview] loadMoreClientDocumentsSuccess',
  props<{ group: ClientDocumentGroup; bucket: DocumentOverviewBucket }>()
);

export const loadMoreClientDocumentsError = createAction(
  '[DocumentOverview] loadMoreClientDocumentsError',
  props<{ group: ClientDocumentGroup; error: string }>()
);
